export default "__VITE_ASSET__Di9prFg1__"